import { all } from 'redux-saga/effects';
import * as accounting from './accounting/_index';
import * as utility from './utility/_index';

export function* rootSaga() {
    yield all([
        // Accounting Sagas
        accounting.watchGetCreditCategories(),
        
        // Utility Sagas
        utility.getDocumentWatcher(),
        utility.getServiceCentersWatcher(),
        utility.getPagedResultWatcher(),
        utility.apiRequestWatcher(),
        utility.getNotificationsWatcher(),
        utility.getAcknowledgeNotificationsWatcher(),
        utility.getClearNotificationsWatcher()
    ]);
}
